module.exports = __webpack_public_path__ + "img/2.85c745d9.jpg";